export default function(theme, props) {
  const label = props.label || '';
  return {
    textField: {
      backgroundColor: theme.colors.eyGrey5,
      height: label.length > 41 && props.useEllipsisLabel === false ? '68px' : '48px',
      maxWidth: '300px',
      border: '1px solid transparent',
    },
    enableTextField:{
      borderBottom: '1px solid #2E2E38',
      "&:hover, &:focus-within":{
        background: '#E1E1E6',
      }
    },
    textFieldFocus: {
      // border: `1px solid ${theme.colors.eyGrey6}`,
    },
    inputRoot: {
      marginTop: label.length > 41 && props.useEllipsisLabel === false ? '40px !important' : '16px',
      paddingLeft: '7px',
      color: theme.colors.eyConfidentGrey,
    },
    dpInputRoot: {
      marginTop: '0px !important',
      paddingLeft: '4px',
      color: theme.colors.eyConfidentGrey,
    },
    inputDom: {},
    formLabel: {
      color: theme.colors.eyConfidentGrey,
      paddingLeft: '8px',
      textAlign: props.align === 'C' ? 'center' : 'left',
    },
    formLabelEllipsis: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
      width: 'calc(100% - 8px)', // 8px accounts for the right padding
      height: '40%',
      top: '-8px',
      transition: 'font-size 0.1s',
    },
    formLabelEllipsisWithIcon: {
      width: 'calc(100% - 35px)', // 35px accounts for the calendar icon
    },
    formControl: {
      transform: 'translate(0, 16px) scale(1)',
    },
    shrink: {
      transform: 'translate(0, 8px) scale(0.75)',
      marginBottom: '8px',
      color: theme.colors.eyGrey1,
    },
    shrinkEllipsis: {
      top: '0px',
      transform: 'translate(0, 8px) ',
      marginBottom: '8px',
      color: theme.colors.eyGrey1,
      fontSize: '0.8em',
      textOverflow: 'ellipsis',
    },
    showPassword: {
      fontFamily: 'caption',
    },
    visibilityIcon: {
      position: 'relative',
      top: '-8px',
    },
    visibilityIconRoot: {
      color: theme.colors.eyGrey2,
    },
    focused: {
      '&$focused': {
        color: theme.colors.eyGrey1,
      },
    },
    hasError: {
      borderBottom: `solid 1px ${theme.colors.red}`,
    },
    labelAsterisk: {
      color: 'red',
      display: "none",
    },
    '@global': {
      '.textfield-error-text': {
        color: '#B9251C',
        margin: '5px 0 5px 0',
        fontSize: '12px',
      },
      '.textfield-error-text svg':{
        verticalAlign:'bottom', fontSize: 14
      }
    }
  };
}
